const { m } = require('minthril');
const { Hero } = require('../../hero');
const { ProductCard } = require('../../productCard');
const { Mission } = require('../../mission');

function Home() {
  return {
    view: ({ attrs: { products, collections = [], onAdd, cartQuantities = {} } }) => {
      const homeCollection = collections.find(collection => collection.title.toLowerCase() === 'home page');
      const homeProductIds = new Set(homeCollection?.products.nodes.map(product => product.id));
      const homeProducts = homeCollection
        ? products.filter(product => homeProductIds.has(product.id))
        : products;
      const featuredProducts = homeProducts.slice(0, 4);
      const remainingProducts = homeProducts.slice(4);

      return m('div.home',
        m(Hero),
        m('section.products', { id: 'featured-parts' },
          m('div.products__intro',
            m('p.products__eyebrow', 'Mid Engine Co'),
            m('h2.products__heading', 'Featured parts'),
            m('p.products__description', 'Specialist parts and upgrades for your mid-engine machine.')
          ),
          featuredProducts.length ? m('section.product-segment.product-segment--featured',
            m('div.product-segment__heading',
              m('p.products__eyebrow', 'Featured parts'),
              m('p.product-segment__count', `${featuredProducts.length} items`)
            ),
            m('div.featured-products',
              m(ProductCard, { product: featuredProducts[0], onAdd, cartQuantity: cartQuantities[featuredProducts[0].variants.nodes[0]?.id] || 0, variant: 'curated' }),
              m('div.featured-products__secondary', featuredProducts.slice(1).map(product =>
                m(ProductCard, { key: product.id, product, onAdd, cartQuantity: cartQuantities[product.variants.nodes[0]?.id] || 0, variant: 'curated' })
              ))
            )
          ) : null,
          remainingProducts.length ? m(Mission) : null,
          remainingProducts.length ? m('section.product-segment',
            m('div.product-segment__heading',
              m('p.products__eyebrow', 'More parts'),
              m('p.product-segment__count', `${Math.min(remainingProducts.length, 6)} items`)
            ),
            m('div.products__grid', remainingProducts.slice(0, 6).map(product =>
              m(ProductCard, { key: product.id, product, onAdd, cartQuantity: cartQuantities[product.variants.nodes[0]?.id] || 0 })
            ))
          ) : null,
          m('a.products__more-link', { href: '/products' }, 'Show the rest →')
        )
      );
    }
  };
}

module.exports = { Home };
